import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import "./Result.css";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { Helmet } from 'react-helmet-async';
import { VictoryPie, VictoryLabel } from 'victory';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';

const Result = ({ lng }) => {
  const history = useHistory();
  const [score, setScore] = useState();
  const [description1, setDescription1] = useState();
  const [description2, setDescription2] = useState();
  const [description3, setDescription3] = useState();
  const [description4, setDescription4] = useState();
  const [list1, setList1] = useState();
  const [list2, setList2] = useState();
  const [list3, setList3] = useState();
  const [list4, setList4] = useState();
  const [list5, setList5] = useState();
  const [scaleData, setScaleData] = useState([]);
  const [colors, setColors] = useState();
  const [scoreLabel, setScoreLabel] = useState("0");
  const [passPersonality, setPassPersonality] = useState();
  const [resultScoreLabel, setResultScoreLabel] = useState();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const { t, i18n } = useTranslation();


  const [isGeneratingPremium, setIsGeneratingPremium] = useState(false);
  const [premiumExpiry, setPremiumExpiry] = useState("");

  useEffect(() => {
      // Koristimo "premiumCouponGenerated" da se ne pomeša sa onim od 40%
      const hasGenerated = localStorage.getItem("premiumCouponGenerated");
      let expiry = localStorage.getItem("premiumCouponExpiry");

      if (!hasGenerated) {
          setIsGeneratingPremium(true);
          
          const d = new Date();
          d.setHours(d.getHours() + 96);
          expiry = d.toISOString();
          localStorage.setItem("premiumCouponExpiry", expiry);

          // Loader od 8 sekundi
          setTimeout(() => {
              setIsGeneratingPremium(false);
              localStorage.setItem("premiumCouponGenerated", "true");
          }, 8000); 
      }

      if (expiry) {
          setPremiumExpiry(expiry);
      }
  }, []);

  const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL
  })

  useEffect(() => {
    const unlisten = history.listen((location, action) => {
      if (action === 'POP') {
        history.push('/');
        window.scrollTo(0, 0);
      }
    });

    return () => {
      unlisten();
    };
  }, [history]);

  useEffect(async () => {
    window.scrollTo(0, 0);
    ReactGA.send({ hitType: "pageview", page: window.location.pathname});

    let email = JSON.parse(localStorage.getItem("customerEmail"));
    let testId = localStorage.getItem("testId");

    const paymentIntent = queryParams.get('payment_intent');
    const paymentIntentClientSecret = queryParams.get('payment_intent_client_secret');

    if (email && testId && paymentIntent && paymentIntentClientSecret) {
      let params = {
        email: email,
        id: testId,
        paymentIntent: paymentIntent,
        paymentIntentClientSecret: paymentIntentClientSecret
      };

      const { data } = await axiosInstance.post("api/result", params);
      
      if (!data.success) {
        let homeRoute = lng !== "en" ? `/${lng}/` : `/`;
        history.push(homeRoute);
      } else {
        setScore(data.conclusion);
        setDescription1(data.description1);
        setDescription2(data.description2);
        setDescription3(data.description3);
        setDescription4(data.description4);
        setList1(data.list1);
        setList2(data.list2);
        setList3(data.list3);
        setList4(data.list4);
        setList5(data.list5);
        setPassPersonality(data.passPersonality);
        setResultScoreLabel(data.resultScoreLabel);

        let realScore = (100 / 110) * data.scorePercentage;
        if (realScore > 100) {
          realScore = 100;
        }
        setScoreLabel(Math.round(realScore));

        let scaleData = [
          { x: 1, y: 0, label: " "},
          { x: 2, y: 0, label: " " },
          { x: 3, y: 0, label: " " },
          { x: 4, y: 0, label: " " },
          { x: 5, y: 0, label: " " },
          { x: 6, y: 0, label: " " }
        ];
        let realScoreForCalculation = Math.round(realScore);
        scaleData.forEach(el => {
          if (el.x !== 6) {
            if (realScoreForCalculation >= 20) {
              el.y = 20;
              realScoreForCalculation = realScoreForCalculation - 20;
            } else {
              el.y = realScoreForCalculation;
              realScoreForCalculation = 0;
            }
          } else {
            const unsolved = 100 - realScore;
            el.y = unsolved;
          }
        })

        setTimeout(() => {
          setScaleData(scaleData)
          setColors(["#ff6347","#ff7f50", "#ffa500", "#32cd32", "#008000", "#D0D0D0"]);
        }, 1000);
      }
    }

  }, [setScore, setDescription1, setDescription2, setDescription3, setDescription4]);

  useEffect(() => {
    try {
      let sendFbEvent = localStorage.getItem("sendFbEvent");
      if (sendFbEvent == null || sendFbEvent == "undefined" || !sendFbEvent) { 
        ReactPixel.track("Purchase", {currency: "USD", value: 14.00});
        localStorage.setItem("sendFbEvent", 1)
      }
    } catch (e) {
      console.error(e);
    }

    setScaleData([
      { x: 1, y: 0, label: " " },
      { x: 2, y: 0, label: " " },
      { x: 3, y: 0, label: " " },
      { x: 4, y: 0, label: " " },
      { x: 5, y: 0, label: " " },
      { x: 6, y: 100, label: " " },
    ])
    setColors(["gray"]);
  }, []);

  const formatDynamicDate = (isoString, lang) => {
    if (!isoString) return "";
    
    const dateObj = new Date(isoString);
    
    // Mapiramo tvoje jezike u zvanične oznake za lokalizaciju
    const locales = {
        en: 'en-US',
        es: 'es-ES',
        de: 'de-DE',
        sr: 'en-US' // Srpski latinica
    };

    const userLocale = locales[lang] || 'en-US';

    return dateObj.toLocaleString(userLocale, {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit'
    });
  };

  const getCourseUrl = () => {
    const rawLevel = localStorage.getItem("resultLevel");
    
    // Ako nema nivoa iz nekog razloga, šaljemo ga na frontend kao fallback
    if (!rawLevel) return "https://turbocodingcourse.com/career-path-frontend";

    // OVO JE FIX: Brišemo skrivene navodnike i razmake
    const storedLevel = rawLevel.replace(/['"]/g, '').trim(); 

    const fullstackLevels = ["A1", "A2", "A-B1"];
    const backendLevels = ["A3"];
    
    if (fullstackLevels.includes(storedLevel)) {
        return "https://turbocodingcourse.com/career-path-fullstack";
    } else if (backendLevels.includes(storedLevel)) {
        return "https://turbocodingcourse.com/career-path-backend";
    } else {
        return "https://turbocodingcourse.com/career-path-frontend";
    }
  };

  const targetCourseUrl = getCourseUrl();

  return (
    <div>
      <Helmet>
        <title>{t("Your Coding Potential Result")}</title>
        <link rel="canonical" href={lng !== "en" ? `https://iscodingforyou.com/${lng}/result/` : `https://iscodingforyou.com/result/`} />
        <meta name="description" content={t("The test score result is sent to your email, and you can also see it below")}/>
        <meta name="robots" content="noindex"/>
      </Helmet>
      <div className="result-content">
        <div className="result-container">
          <h1 className="result-main-title">{t("THANK YOU FOR TAKING OUR TEST")}</h1>
          <h2 className="result-main-title-2">{t("The test score result is sent to your email, and you can also see it below")}</h2>
          <div className="result-description-main">
            <div className="result-title">
              <p className="result-title-1">{t("THE RESULT")}:</p>
              <p className="result-title-2">{score}</p>
            </div>
          </div>


          <div className="result-description">
            <div className="details-score">
                <div className="details-score-logical">
                  <p className="test-name">{t("Logical test score")}</p>
                  <p className="test-name-result">{t(resultScoreLabel)}</p>
                  <div className="score-scale">
                    <svg width={300} height={300} viewBox='0 0 365 365'>
                      <VictoryPie
                        startAngle={-135}
                        endAngle={135}
                        data={scaleData}
                        innerRadius={100}
                        colorScale={colors}
                        animate={{ duration: 2000 }}
                        standalone={false}
                        width={360} height={360}
                      />
                      <VictoryLabel
                        textAnchor="middle" verticalAnchor="middle"
                        x={180} y={180}
                        style={{fontSize: 60}}
                        text={scoreLabel}
                      />
                    </svg>
                  </div>
                </div>
                <div className="details-score-personality">
                  <p className="test-name">{t("Personality test")}</p>
                  {passPersonality === true ? (
                      <p className="test-name-result">{t("Passed")}</p>
                    ) : (
                      <div>
                        {passPersonality === false ? (
                          <p className="test-name-result">{t("Not Passed")}</p>
                        ) : (
                          <p className="test-name-result"></p>
                        )}
                      </div>
                  )}
                  <div className="result-image-wrap">
                  {passPersonality === true ? (
                      <img src="/pass-personality.svg" className="image-summary" alt="summary-banner"  width="180" height="auto"/>
                    ) : (
                      <div>
                        {passPersonality === false ? (
                          <img src="/fail-personality.svg" className="image-summary" alt="summary-banner"  width="180" height="auto"/>
                        ) : (
                            <div>
                            </div>
                        )}
                      </div>
                  )}
                  </div>
                </div>
              </div>
            <div className="result-subdescription result-subdescription-report">

              <p className="result-text result-report">{t("DETAILED REPORT")}</p>
            </div>
          </div>

          <div className="result-description-white">
            <div className="result-subdescription">
              <p className="result-text">{description1}</p>
            </div>
          </div>

          <div className="result-description">
            <div className="result-subdescription">
              <p className="result-text">{description2}</p>
            </div>
          </div>

          {/* --- REDIZAJNIRANA LISTA (Key Takeaways) --- */}
          <div className="result-description-white">
            <div className="result-subdescription">
              <p className="result-text" style={{marginBottom: '20px'}}>{description3}</p>
              
              {list1 ? (
                <div className="result-key-points">
                  <div className="key-point-card">
                      <div className="key-point-icon">📌</div>
                      <div className="key-point-text">{list1}</div>
                  </div>
                  {list2 && (
                    <div className="key-point-card">
                        <div className="key-point-icon">📌</div>
                        <div className="key-point-text">{list2}</div>
                    </div>
                  )}
                  {list3 && (
                     <div className="key-point-card">
                        <div className="key-point-icon">📌</div>
                        <div className="key-point-text">{list3}</div>
                    </div>
                  )}
                  {list4 && (
                     <div className="key-point-card">
                        <div className="key-point-icon">📌</div>
                        <div className="key-point-text">{list4}</div>
                    </div>
                  )}
                   {list5 && (
                     <div className="key-point-card">
                        <div className="key-point-icon">📌</div>
                        <div className="key-point-text">{list5}</div>
                    </div>
                  )}
                </div>
                ) : (
                <div/>
              )}
            </div>
          </div>
           {/* --------------------------------------------- */}


          {description4 ? (
            <div className="result-description result-description-last">
              <div className="result-subdescription">
                <p className="result-text">{description4}</p>
              </div>
            </div>
            ) : (
            <div/>
            )}
        </div>

        <div className="result-container learning-resources">
          
          <div className="premium-course-box" style={{ 
              backgroundColor: "#f8f9fa", 
              border: "1px solid #e0e0e0",
              borderRadius: "12px",
              padding: "30px",
              textAlign: "center",
              boxShadow: "0 10px 25px rgba(0,0,0,0.05)",
              marginTop: "30px"
          }}>
             
             <div style={{ 
                  display: "inline-block", 
                  backgroundColor: "#030E4F", 
                  color: "#fff", 
                  padding: "5px 15px", 
                  borderRadius: "20px", 
                  fontWeight: "bold",
                  fontSize: "14px",
                  marginBottom: "15px",
                  textTransform: "uppercase",
                  letterSpacing: "1px"
              }}>
                  ⭐ {t("VIP Reward Unlocked")}
              </div>

              <h2 style={{ color: "#030E4F", marginBottom: "15px", fontSize: "24px", fontWeight: "bold" }}>
                  {t("Take the final step towards your new career.")}
              </h2>

              <p style={{ color: "#555", fontSize: "16px", lineHeight: "1.6", marginBottom: "25px" }}>
                  {t("As a reward for investing in your future, you've unlocked our highest tier discount. Use this exclusive code to get a massive")} 
                  <strong style={{ color: "#030E4F", fontSize: "18px" }}> {t("80% OFF")} </strong> 
                  {t("on the")} <strong>{t("Annual Premium Plan")}</strong> {t("of the Turbo Coding Course.")}
              </p>

              {/* KUTIJA ZA KOD SA SIMULACIJOM LOADERA */}
              <div style={{ 
                  backgroundColor: "#fff", 
                  border: "2px dashed #030E4F", 
                  borderRadius: "8px", 
                  padding: "15px", 
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minWidth: "280px",
                  minHeight: "70px",
                  margin: "0 auto 20px auto",
                  maxWidth: "max-content"
              }}>
                  {isGeneratingPremium ? (
                      <div style={{ fontSize: "16px", color: "#666", display: "flex", alignItems: "center", gap: "10px" }}>
                          <span className="spinner" style={{ animation: "spin 1s linear infinite", display: "inline-block" }}>⚙️</span> 
                          {t("Generating your VIP code...")}
                      </div>
                  ) : (
                      <span style={{ fontSize: "28px", fontWeight: "900", color: "#030E4F", letterSpacing: "2px" }}>
                          LE9ZUQS80
                      </span>
                  )}
              </div>

              {/* TAJMER: Prikazuje se tek kad se kod generiše */}
              {!isGeneratingPremium && premiumExpiry && (
                  <p style={{ color: "#d32f2f", fontWeight: "bold", fontSize: "15px", marginBottom: "25px" }}>
                      ⏳ {t("Offer valid until")} {formatDynamicDate(premiumExpiry, i18n.language)}
                  </p>
              )}

              <div className="resource-link-wrap">
              <a href={targetCourseUrl} target="_blank" rel="noreferrer" 
                  style={{
                      display: "inline-block",
                      backgroundColor: "#030E4F",
                      color: "white",
                      padding: "15px 30px",
                      textDecoration: "none",
                      fontWeight: "bold",
                      fontSize: "18px",
                      borderRadius: "8px",
                      boxShadow: "0 4px 10px rgba(3, 14, 79, 0.3)",
                      transition: "transform 0.2s ease, background-color 0.2s ease",
                      width: "100%",
                      maxWidth: "350px"
                  }}
              >
                  {t("Claim Your 80% Discount")} &rarr;
              </a>
              </div>
          </div>
        </div>
        {/* --------------------------------------------- */}
        
      </div>
      <div className="result-social">
        <h2 className="social-title">{t("Send the test to your friends and let them try too")}</h2>
        <div className="social-icons">
          <a href="whatsapp://send?text=Is Coding For You. Online Test https://iscodingforyou.com">
            <img src="/social-wa.png" className="social-icon" alt="WA share test" width="50" height="50"/>
          </a>
          <a href="https://www.facebook.com/sharer/sharer.php?u=https://www.iscodingforyou.com" target="_blank">
            <img src="/social-fb.png" className="social-icon" alt="WA share test" width="50" height="50"/>
          </a>
          <a href="https://twitter.com/intent/tweet?url=https://www.iscodingforyou.com&text=Is Coding For You. Online Test" target="_blank">
            <img src="/social-tw.png" className="social-icon" alt="WA share test" width="50" height="50"/>
          </a>
          <a href="https://www.linkedin.com/shareArticle?url=https://www.iscodingforyou.com&title=Is Coding For You. Online Test" target="_blank">
            <img src="/social-ln.png" className="social-icon" alt="WA share test" width="50" height="50"/>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Result;